"use strict";

// WizardConstants
var Constants = {};

Constants.WIZARDS = {
	ACCOUNT_MESSAGES: "wizardAccountDisplayMessages",
	BUTTON_LABELS: "wizardButtonLabels",
	CHILD_COMMUNICATIONS_MESSAGES: "wizardChildCommunicationsWriteDisplayMessages",
	COMPANY_ERROR_MESSAGES: "wizardCompanyErrorMessages",
	CHECKOUT_MESSAGES: "wizardCheckoutDisplayMessages",
	COUPON_DISPLAY_MESSAGES: "wizardCouponDisplayMessages",
	CREDIT_CARD_MESSAGES: "wizardCreditCardDisplayMessages",
	DOCUMENTS_CONFIGURATION: "wizardDocumentsConfiguration",
	DOCUMENTS_DISPLAY_MESSAGES: "wizardDocumentsDisplayMessages",
	EMAIL_SUBSCRIPTIONS: "wizardEmailSubscriptions",
	EMAIL_SUBSCRIPTION_MESSAGES: "wizardEmailSubscriptionDisplayMessages",
	EVENT_REGISTRATION_DISPLAY_MESSAGES: "wizardEventRegistrationDisplayMessages",
	EVENT_SEARCH: "wizardEventSearch",
	FORM_VALIDATION_MESSAGES: "wizardFormValidationDisplayMessages",
	LAST_MINUTE_DONATION_UPSELL: "wizardLastMinuteDonationUpsell",
	LOGIN_MESSAGES: "wizardLoginDisplayMessages",
	PAYPAL_MESSAGES: "wizardPayPalDisplayMessages",
	PLEDGE_STATEMENT_ENTRY: "wizardPledgeStatementEntry",
	PRODUCT_DOWNLOAD_DISPLAY_MESSAGES: "wizardProductDownloadDisplayMessages",
	REPORT_DISPLAY_MESSAGES: "wizardReportDisplayMessages",
	RECURRING_START_DATE_DROPDOWN_VALUES: "wizardRecurringStartDateDropdownValues",
	SAVED_PAYMENT_DISPLAY_MESSAGES: "wizardSavedPaymentsDisplayMessages",
	SHIPPING_MESSAGES: "wizardShippingDisplayMessages",
	SHOPPING_CART_MESSAGES: "wizardShoppingCartDisplayMessages",
	SPONSORSHIP_DEFAULTS: "wizardSponsorshipDefaults",
	SPONSORSHIP_DISPLAY_MESSAGES: "wizardSponsorshipDisplayMessages",
	SUBSCRIPTION_DISPLAY_MESSAGES: "wizardSubscriptionDisplayMessages",
	YEAR_END_GIVING_STATEMENT_DISPLAY_MESSAGES: "wizardYearEndGivingStatementDisplayMessages"
};

Constants.ACCOUNT_MESSAGE_FIELDS = {
	ACCOUNT_CREATE_ERROR: "accountCreateError",
	ACCOUNT_PASSWORDS_MISMATCH: "accountPasswordsMismatch",
	EMAIL_MISSING: "emailMissing",
	FORGOT_PASSWORD_ERROR: "forgotPasswordError",
	RESET_TOKEN_MISSING: "resetTokenMissing",
	PASSWORD_CHANGE_ERROR: "passwordChangeError",
	SAVED_PAYMENT_ERROR: "savedPaymentError"
};

Constants.SAVED_PAYMENT_DISPLAY_MESSAGES_FIELDS = {
	CANNOT_DELETE_BECAUSE_OF_RECURRING: "cannotDeleteBecauseOfRecurring",
	SAVED_PAYMENT_FOR_RECURRING_ERROR:"savedPaymentForRecurringError",
	CANNOT_DELETE_BECAUSE_OF_AUTO_RENEWING_SUBSCRIPTION: "cannotDeleteBecauseOfAutoRenewingSubscription",
	SAVED_PAYMENT_FOR_SUBSCRIPTION_ERROR: "savedPaymentForSubscriptionError",
	MAKE_PRIMARY_CONFIRMATION_MESSAGE: "makePrimaryConfirmation",
	MAKE_PRIMARY_CONFIRMATION_CONFIRM_BUTTON_TEXT: "makePrimaryConfirmButtonText",
	MAKE_PRIMARY_CONFIRMATION_CANCEL_BUTTON_TEXT: "makePrimaryCancelButtonText",
	MAKE_PRIMARY_ERROR_TEXT: "makePrimaryErrorText",
	REMOVE_DEFAULT_CONFIRMATION_MESSAGE: "removeDefaultConfirmation",
	REMOVE_DEFAULT_CONFIRMATION_CONFIRM_BUTTON_TEXT: "removeDefaultConfirmButtonText",
	REMOVE_DEFAULT_CONFIRMATION_CANCEL_BUTTON_TEXT: "removeDefaultCancelButtonText",
	REMOVE_DEFAULT_ERROR_TEXT: "removeDefaultErrorText"
};

Constants.BRAINTREE_MESSAGE_FIELDS = {
	PAYMENT_FORM_UNAVAILABLE: "paymentFormUnavailable",
	CREDIT_CARD_FORM_INVALID: "creditCardFormInvalid",
	THREEDSECURE_SERVICE_UNAVAILABLE: "threeDSecureUnavailable",
	THREEDSECURE_VERIFICATION_FAILURE: "threeDSecureVerificationFailure"
};

Constants.BUTTON_LABEL_FIELDS = {
	YES: "yesButtonLabel",
	NO: "noButtonLabel",
	OK: "okButtonLabel",
	CANCEL: "cancelButtonLabel"
};

Constants.CARDCONNECT_MESSAGE_FIELDS = {
	CARD_NUMBER_TOKEN: "tokenMissing"
};

Constants.CHECKOUT_MESSAGE_FIELDS = {
	CHECKOUT_ERROR: "checkoutError",
	GIFT_AMOUNT_INSUFFICIENT: "giftAmountInsufficient",
	GIFT_GROUP_AMOUNT_INSUFFICIENT: "giftGroupAmountInsufficient",
	AVAILABLE_QUANTITY: "availableQuantity",
	ITEM_MOVE_FAILED: "itemMoveFailed",
	ITEM_REMOVE_FAILED: "itemRemoveFailed",
	INVALID_COUPON_CODE: "invalidCouponCode",
	COUPON_APPLICATION: "couponApplication",
	CHECKOUT_WHILE_SHIPPING_AND_TAX_ARE_CALCULATING: "checkoutWhileShippingAndTaxAreCalculating"
};

Constants.COUPON_MESSAGE_FIELDS = {
	DEFAULT_ERROR: "defaultCouponError",
	GEOGRAPHIC_ERROR: "couponGeographicError"
};

Constants.CREDIT_CARD_MESSAGE_FIELDS = {
	EXPIRATION_DATE_INCOMPLETE: "expirationDateIncomplete",
	EXPIRATION_MONTH_INVALID: "expirationMonthInvalid",
	EXPIRATION_YEAR_INVALID: "expirationYearInvalid",
	VERIFICATION_NUMBER_INVALID: "verificationNumberInvalid"
};

Constants.LAST_MINUTE_DONATION_UPSELL_FIELDS = {
	CALCULATION: "lastMinuteDonationCalculation",
	AMOUNT: "lastMinuteDonationAmount"
};

Constants.LAST_MINUTE_DONATION_CALCULATION_VALUES = {
	CONSTITUENT_DECLINED: "none",
	PERCENTAGE: "percentage",
	STATIC_AMOUNT: "static"
};

Constants.EMAIL_SUBSCRIPTION_MESSAGE_FIELDS = {
	EMAIL_SUBSCRIPTION_FORM_ERROR: "emailSubscriptionFormError",
	MY_EMAIL_SUBSCRIPTIONS_ERROR: "myEmailSubscriptionsError"
};

Constants.EMAIL_SUBSCRIPTIONS_FIELDS = {
	AVAILABLE_EMAIL_SUBSCRIPTION_TYPES: "availableEmailSubscriptionTypes",
	DEFAULT_CANCEL_REASON: "defaultCancelReason"
};

Constants.EVENT_REGISTRATION_DISPLAY_MESSAGES_Fields = {
	APPLY_GROUP_CODE_ERROR: "applyGroupCodeError",
	ADD_TO_CART_GROUP_CODE_ERROR: "cartGroupCodeError",
	DELETE_REGISTRANT: "deleteRegistrant"
};

Constants.EVENT_SEARCH_FIELDS = {
	DEFAULT_COUNTRY: "defaultCountry"
};

Constants.FORM_VALIDATION_MESSAGE_FIELDS = {
	REQUIRED_FIELDS: "requiredFields",
	INVALID_DATE: "invalidDateProvided"
};

Constants.LANDING_PAGE_PERMISSION_CATEGORY_CODES = {
	ACCOUNT: "ACCOUNT",
	ACCOUNT_MARKETING: "ACCTMKATTR"
};

Constants.LOGIN_MESSAGE_FIELDS = {
	LOGIN_ERROR: "loginError",
	LOGOUT_ERROR: "logoutError"
};

Constants.PAYPAL_MESSAGE_FIELDS = {
	CREATE_ERROR: "payPalCreateError",
	CHECKOUT_ERROR: "payPalCheckoutError",
	ADDITIONAL_INFORMATION_REQUIRED: "payPalAdditionalInformationRequired"
};

Constants.PLEDGE_STATEMENT_ENTRY_FIELDS = {
	INVALID_ACCOUNT_OR_PLEDGE_STATEMENT_MESSAGE: "invalidAccountOrPledgeStatementMessage",
	SESSION_ABANDONMENT_WARNING_MESSAGE: "pledgeStatementSessionAbandonmentWarningMessage"
};

Constants.PRODUCT_DOWNLOAD_MESSAGE_FIELDS = {
	UNDOWNLOADABLE_ERROR: "undownloadableError"
};

Constants.PROJECT_COMPLETION_DEFAULTS_REQUIRE_DONATION_VALUES = {
	NO: "no",
	WITH_PREMIUM: "premium",
	YES: "yes"
};

Constants.SHIPPING_MESSAGE_FIELDS = {
	SHIPPING_METHOD_MISSING: "shippingMethodMissing",
	GIFT_RECIPIENT_MISSING: "giftRecipientMissing",
	SHIPPING_ADDRESS_INCOMPLETE: "shippingAddressIncomplete",
	SHIPPING_ADDRESS_MISSING: "shippingAddressMissing",
	NEW_SHIPPING_ADDRESS_INCOMPLETE: "newShippingAddressIncomplete",
	SHIPPING_METHOD_NOT_AVAILABLE: "shippingMethodNotAvailable",
	SHIPPING_METHOD_FREE: "shippingMethodFree",
	SHIPPING_INCALCULABLE: "shippingIncalculable"
};

Constants.SHOPPING_CART_MESSAGE_FIELDS = {
	ADD_TO_CART_ERROR: "addToCartError"
};

Constants.SPONSORSHIP_DEFAULTS_FIELDS = {
	DEFAULT_AMOUNT: "defaultAmount",
	DEFAULT_FREQUENCY: "defaultFrequency"
};

Constants.SPONSORSHIP_DISPLAY_MESSAGES_FIELDS = {
	SPONSORSHIP_NOT_AVAILABLE: "sponsorshipNotAvailable"
};

Constants.TOKENEX_MESSAGE_FIELDS = {
	TOKEN_MISSING: "tokenMissing"
};

Constants.TSYS_TSEP_MESSAGE_FIELDS = {
	GENERIC: "generic"
};

Constants.YEAR_END_GIVING_STATEMENT_MESSAGE_FIELDS = {
	INVALID_DATE: "invalidDateProvided",
	INVALID_DATE_RANGE: "invalidDateRange"
};

Constants.DOCUMENTS_COFIGURATION_FIELDS = {
	SHOULD_OPEN_PDF_IN_NEW_TAB: "shouldOpenPdfDocumentsInNewTab"
}

Constants.DOCUMENTS_DISPLAY_MESSAGES_FIELDS = {
	DOWNLOAD_UNAVAILABLE: "downloadUnavailable",
	DOWNLOAD_UNAUTHORIZED: "downloadUnauthorized",
	DOWNLOAD_ERROR: "downloadError",
	DOCUMENT_TYPE_CHANGED: "documentTypeChanged",
	DOCUMENT_TYPE_ERROR: "documentTypeError"
}

Constants.REPORT_DISPLAY_MESSAGES_FIELDS = {
	DOWNLOAD_ERROR: "downloadError",
	REPORT_CONFIGURATION_CHANGED: "reportConfigurationChanged"
}

module.exports = Constants;
